import { ResetPasswordScreen } from "@/src/screens/reset-password-screen";

export default function ResetPasswordRoute() {
  return <ResetPasswordScreen />;
}
